// Products Module Initialization
// This file contains all side effects for the products module.
// It is imported by src/imports.ts at application startup.

import { PRODUCTS_VIEW, PRODUCT_DETAILS_VIEW } from '@/products'
import { registerRoute } from '@/router'
import { useContaCommand } from '@/commandbar/commandBar.service'
import { NavGroup, registerNavigationEntry } from '@/navigation'
import { useBreadCrumbs } from '@/breadcrumbs/useBreadCrumbs'

const { registerNavigationCommand } = useContaCommand()
const { buildSimpleCrumb } = useBreadCrumbs()

const products_view_label = 'Produkter'
const icon = 'i-ph-shopping-cart-fill'

// PRODUCTS_VIEW
registerRoute(PRODUCTS_VIEW)
registerNavigationCommand({
    route: PRODUCTS_VIEW,
    label: products_view_label,
    icon
})
registerNavigationEntry(NavGroup.MISC, {
    title: products_view_label,
    key: 'products',
    icon,
    target: PRODUCTS_VIEW,
    sortOrder: 2
})
buildSimpleCrumb(PRODUCTS_VIEW, products_view_label, icon)

// PRODUCT_DETAILS_VIEW
registerRoute(PRODUCT_DETAILS_VIEW)
